import { useMutation } from "@tanstack/react-query";
import { UpdateUserParams, updateUser } from "supabase/users";
import { queryClient } from "utils";

export const useUpdateUser = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: (user: UpdateUserParams) => {
      return updateUser(user);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["users"],
      });
      queryClient.invalidateQueries({
        queryKey: ["user", variables.uid],
      });

      onSuccess();
    },
  });

  return mutation;
};
